import React, { useState } from "react";

// components imports
import SubscribersTable from "../../../../../Components/BoltTable/BoltTable";
// apis imports
import { fetchAllNewsLetters } from "../../../../../services/admin.services";
// library imports
import { MdVerified, MdUnpublished } from "react-icons/md";
import { convertTime } from "../../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const Subscribers = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [subscribersList, setSubscribersList] = useState([]);

  const columns = [
    {
      id: 1,
      label: t("newsletter.email"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("newsletter.verified"),
      render: (row) => (
        <>
          {["1", "true", true].includes(row.is_verified) ? (
            <MdVerified size={15} color="teal" />
          ) : (
            <MdUnpublished size={15} color="lightgrey" />
          )}
        </>
      ),
      width: "200px",
    },
    {
      id: 3,
      label: t("newsletter.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
  ];

  const fetchAllSubscribers = async (page, perPage, filter) => {
    const response = await fetchAllNewsLetters(page, perPage, filter);
    if (!response.error) {
      setSubscribersList(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  return (
    <>
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <SubscribersTable
          tableTitle={t("newsletter.subscribers")}
          tableId="subscriberTableForAdminNewsletter"
          message={t("newsletter.noSubscribersAvailableToDisplay")}
          searchPlaceHolder={t("newsletter.searchSubscribers")}
          columns={columns}
          data={subscribersList}
          getAllData={fetchAllSubscribers}
        />
      </div>
    </>
  );
};

export default Subscribers;
